<template>
  <q-page fluid class="row">
    <div style="max-height: calc(100vh - 82px)" class="row full-width">
      <div class="col-12 col-md-6 q-pa-sm" :style="`height: 100%;`">
        <div class="row" :style="`height: 100%;`">
          <div class="col-12">
            <q-card class="q-mb-sm mergingList">
              <q-card-section>
                <h2 style="display: inline-block" class="q-my-none header">
                  Merging Surveys
                </h2>
                <q-btn
                  color="primary"
                  flat
                  no-caps
                  :disable="currentScanSelection.length < 2"
                  icon="mdi-check"
                  label="Confirm Merge"
                  class="absolute-right"
                  @click="openConfirmMergeDialog"
                >
                </q-btn>
              </q-card-section>
              <q-card-section class="q-py-none">
                <q-scroll-area style="height: 200px">
                  <div class="row">
                    <div
                      class="col-12 survey"
                      :style="`${
                        selectedMergingScan == scan.id
                          ? 'border: 1px solid #3284E3;'
                          : ''
                      } cursor: hover; `"
                      v-for="(scan, index) in currentScanSelection"
                      :key="`scan_${index}`"
                      @click="
                        $store.dispatch(
                          'updateSelectedMergingScan',
                          scan.id == selectedMergingScan ? null : scan.id
                        )
                      "
                    >
                      <div class="row">
                        <div class="col-10">
                          {{ scan.name }}
                        </div>
                        <div class="col-2">
                          <q-btn
                            icon="mdi-close"
                            size="sm"
                            flat
                            color="primary"
                            @click.stop="removeScan(index)"
                          ></q-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </q-scroll-area>
              </q-card-section>
            </q-card>
          </div>
          <div class="col-12" :style="`height: calc(100% - 266px);`">
            <scannedSurveys
              :collapseOnSelect="true"
              :multiSelect="true"
              :filterOutCurrentScanSelection="currentScanSelection"
              @addSurvey="addSurvey"
            />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 q-pa-sm" style="height: calc(100%)">
        <mergingSurveysMap />
      </div>
    </div>
    <q-dialog v-model="confirmMergeDialog">
      <q-card>
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              Survey
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="confirmMergeDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <scheduledSurveyForm
            ref="editForm"
            :surveyData="formData"
            :creatingMerge="true"
            :scansToBeMerged="currentScanSelection"
            @close="confirmMergeDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
            @uploadDataLoading="(state) => (dataUploadLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.createMergedSurvey()"
                :loading="saveLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-plus"
                label="Create Merge"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
// import VueApexCharts from "vue-apexcharts";

import { mapGetters } from "vuex";
import scannedSurveys from "@/components/scheduledSurveys/scannedSurveys.vue";
import mergingSurveysMap from "@/components/scheduledSurveys/mergingSurveysMap.vue";
import scheduledSurveyForm from "@/components/scheduledSurveys/scheduledSurveyForm.vue";

import moment from "moment";

export default {
  components: {
    scannedSurveys,
    mergingSurveysMap,
    scheduledSurveyForm,
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentZoom",
      "selectedMergingScan",
      "currentZoomScanDataLoading",
    ]),
  },
  props: {
    source: String,
  },
  watch: {},
  data: () => ({
    currentScanSelection: [],
    order: {},
    formData: null,
    confirmMergeDialog: false,

    saveLoading: false,
    dataUploadLoading: false,
  }),
  mounted() {
    this.$store.dispatch("resetSurveyReports");
  },
  methods: {
    dotClicked(point) {
      this.$refs.reportData.dotClicked(point);
    },
    addSurvey(survey) {
      this.currentScanSelection.push(survey);
      this.loadScanSurveys();
    },
    loadScanSurveys() {
      let idList = [];
      this.currentScanSelection.forEach((element) => {
        idList.push(
          element.mergedScans
            ? element.mergedScans.map((s) => s.id)
            : [element.id]
        );
      });

      this.$store.dispatch("loadSurveyScanDataForZoom", {
        idList: idList,
        zoom: this.currentZoom == 0 ? 5 : this.currentZoom,
        disableNormalization: true,
      });
    },
    openConfirmMergeDialog() {
      this.formData = this.currentScanSelection[0];
      this.confirmMergeDialog = true;
    },
    confirmMerge() {
      // this.$store.dispatch()
    },
    removeScan(index) {
      this.currentScanSelection.splice(index, 1);
      this.loadScanSurveys();
    },
  },
};
</script>

<style lang="scss">
.mergingList {
  .header {
    font-size: 16pt;
    line-height: 18pt;
  }

  .survey {
    cursor: pointer;
    transition: 0.3s;
    padding: 5px;
    border: 1px solid white;
    margin: 2px 0px 2px 0px;
  }

  .survey:hover {
    cursor: pointer;
    border: 1px solid gray;
  }
}
</style>
